import React, { Component } from "react";
import { Menu } from "semantic-ui-react";

class BuscaProvincias extends Component {
  state = {
    selected: ""
  };

  handleClick = (e, { name }) => {
    this.setState({ selected: name });

    this.props.handleChange(name);
  };

  render() {
    return (
      <Menu>
        <Menu.Item
          name="albacete"
          onClick={this.handleClick}
          active={this.state.selected === "albacete"}
        />
        <Menu.Item
          name="alicante"
          onClick={this.handleClick}
          active={this.state.selected === "alicante"}
        />
        <Menu.Item
          name="murcia"
          onClick={this.handleClick}
          active={this.state.selected === "murcia"}
        />
      </Menu>
    );
  }
}

export default BuscaProvincias;



// WEBPACK FOOTER //
// ./src/pages/ventas/ventas/navMenu/BuscaProvincias.jsx